import { Box, Breadcrumbs, Link, Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import * as services from "./../../services/saleng";

function formatNumber(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Reports = () => {
  const { branchId } = useParams();
  const [rows, setRows] = useState([]);
  const [branchData, setBranchData] = useState();

  const columns = [
    { field: "id", headerName: "ลำดับ", flex: 0, width: 70 },
    {
      field: "image",
      headerName: "รูปภาพ",
      flex: 0,
      width: 100,
      renderCell: (params) => {
        if (params.value) {
          return (
            <img
              src={params.value}
              style={{ width: "50px", height: "50px" }}
              alt=""
            />
          );
        }
      },
    },
    { field: "productName", headerName: "ชื่อสินค้า", flex: 2 },
    { field: "subCategory", headerName: "หมวดหมู่ย่อย", flex: 1 },
    { field: "category", headerName: "ประภท", flex: 1 },
    {
      field: "weight",
      headerName: "จำนวนสต็อค",
      flex: 1,
      type: "number",
      renderCell: (params) => {
        return (
          <>
            {formatNumber(params.row.weight)}
            <span style={{ color: "gray" }}>{" กิโล"}</span>
          </>
        );
      },
    },
    // {
    //   field: "description",
    //   headerName: "ข้อมูลเพิ่มเติม",
    //   flex: 0,
    //   sortable: false,
    //   filterable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     console.log("params", params);
    //     return (
    //       <SubjectIcon
    //         onClick={() => window.open("/reports/" + params.row.transactionId)}
    //       />
    //     );
    //   },
    // },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [branchResponse, categoriesResponse, transactionsResponse] =
          await Promise.all([
            services.getBranch(branchId),
            services.getCategories(),
            services.getBranchTransaction(branchId),
          ]);

        const categories = categoriesResponse.data.data;
        const filteredSortDataWithIndex = categories.flatMap((category) =>
          category.subCategories.flatMap((subCategory) =>
            subCategory.products.map((product) => ({
              productId: product.id,
              image:
                product.image || "https://placehold.co/100x100?text=Not+Found",
              title: product.title,
              subCategoryId: subCategory.id,
              subCategory: subCategory.title,
              categoryId: category.id,
              category: category.title,
            }))
          )
        );

        const transactions = transactionsResponse.data.data;
        const branch = branchResponse.data.data;
        setBranchData(branch);

        const mergedItems = Object.values(
          transactions
            .flatMap((d) => d.items)
            .reduce((acc, { id, transactionId, ...item }) => {
              if (!acc[item.productId]) {
                acc[item.productId] = { ...item };
              } else {
                acc[item.productId].weight += item.weight;
                acc[item.productId].total += item.total;
              }
              return acc;
            }, {})
        );

        const finalData = mergedItems
          .map((item) => {
            const matchedProduct = filteredSortDataWithIndex.find(
              (product) => product.productId === item.productId
            );

            return {
              ...item,
              image:
                matchedProduct?.image ||
                "https://placehold.co/100x100?text=Not+Found",
              subCategoryId: matchedProduct?.subCategoryId || null,
              subCategory: matchedProduct?.subCategory || "ไม่ระบุ",
              categoryId: matchedProduct?.categoryId || null,
              category: matchedProduct?.category || "ไม่ระบุ",
            };
          })
          .map((item, index) => ({ ...item, id: index + 1 }));

        setRows(finalData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [branchId]);

  return (
    <div>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2, mb: 2 }}>
        <Link underline="hover" color="inherit" href="/">
          หน้าแรก
        </Link>
        <Link underline="hover" color="inherit" href="/branches">
          จัดการสาขา
        </Link>
        <Typography color="text.primary">คลังสินค้า</Typography>
      </Breadcrumbs>

      <Typography component="h2" variant="h5" sx={{ mb: 2 }}>
        คลังสินค้า <b>{branchData?.name}</b>
      </Typography>
      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
              disableRowSelectionOnClick
              getRowId={(row) => row.productId}
            />
          </Paper>
        </Box>
      </Box>
    </div>
  );
};

export default Reports;
